export default "__VITE_ASSET__DXgddZkl__"